import React__default, { useCallback } from 'react';

/**
 * Combine renderers of each plugin.
 */
function useLeafRenderers(plugins) {
  const Leaf = useCallback(props => {
    // workaround for children readonly error.
    const leafProps = {
      ...props
    };
    plugins.forEach(({
      renderLeaf
    }) => {
      if (!renderLeaf) return;
      leafProps.children = renderLeaf(leafProps);
    });
    return /*#__PURE__*/React__default.createElement("span", leafProps.attributes, leafProps.children);
  }, [plugins]);
  return useCallback(function renderElement(leafProps) {
    // A wrapper tag component to make useContext get correct value inside.
    return /*#__PURE__*/React__default.createElement(Leaf, leafProps);
  }, [Leaf]);
}

export { useLeafRenderers };
